export default {
  id: undefined,
  type: 'property',
  attributes: {
    default: true,
    square_feet: null,
  },
}
